import md5 from 'js-md5';
import { Db } from 'src/model/db/db';
import { queryBot2Many } from 'boot/axios';
import moment from 'moment';
import resultService from 'src/services/result.service';

export const AUTH_LOG_TYPE = {
    1: 'Вход',
    2: 'Выход',
    3: 'Создание',
    4: 'Восстановление',
    5: 'Смена email',
    6: 'Установка флага "Суперадмин"',
    7: 'Снятие флага "Суперадмин"',
    8: 'Изменение роли',
    9: 'Изменение провайдера',
    10: 'Изменение курса',
};

async function getKeyFromTemporary (uuid) {
    function getUserKey (userChatId) {
        const key = md5(`${userChatId}`).substring(0, 12);
        return key;
    }

    const rows = await queryBot2Many('auth-temp-url', { uuid });
    const [row] = rows;
    if (!row) {
        window.location.href = `${window.location.origin}/incorrect_url`;
    }
    const chatId = row?.chat_id;
    if (!chatId) { return undefined; }
    return getUserKey(chatId);
}

function auth ({ store, query }) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve) => {
        let { key } = query;
        const { t } = query;
        // Временная ссылка
        if (t) {
            // сгенерировать ключ доступа если временная ссылка существует
            key = await getKeyFromTemporary(t);
        } else if (!key) {
            key = localStorage.getItem('key');
            localStorage.setItem('key', key);
        }

        if (!key) { resolve(false); return; }
        if (key === 'null') { resolve(false); return; }

        const db = new Db();
        db.auth(key).then((user) => {
            resultService.init(user?.id);
            if (!user) {
                localStorage.removeItem('key');
            } else {
                // раскомментить если нужно чтобы после одного захода пользователь оставался в системе
                localStorage.setItem('key', key);
                if (query?.key) {
                    localStorage.setItem('last-key-auth', moment().format('YYYY-MM-DD HH:mm'));
                }
            }
            store.commit('pages/setUser', user);
            resolve(user);
        });
    });
}

export default auth;

export function logoutClean () {
    localStorage.removeItem('key');
    // localStorage.removeItem('unti.accessToken');
    localStorage.removeItem('unti.expiresIn');
    localStorage.removeItem('unti.refreshToken');
    localStorage.removeItem('unti.scope');
    localStorage.removeItem('unti.tokenType');
}
